import { render, staticRenderFns } from "./StockConstructor.vue?vue&type=template&id=64388200"
import script from "./StockConstructor.vue?vue&type=script&lang=js"
export * from "./StockConstructor.vue?vue&type=script&lang=js"
import style0 from "./StockConstructor.vue?vue&type=style&index=0&id=64388200&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64388200')) {
      api.createRecord('64388200', component.options)
    } else {
      api.reload('64388200', component.options)
    }
    module.hot.accept("./StockConstructor.vue?vue&type=template&id=64388200", function () {
      api.rerender('64388200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock-constructor/StockConstructor.vue"
export default component.exports